import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createEvent } from "../../../api/events.api";
import ErrorResponse from "../../../components/ErrorResponse";
import BriefingEditor from "../../../components/event/briefing/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";

const BriefingCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push('/event/briefing');
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    submitExecute(createEvent('PA', data));
  }

  return (
    <div className="content scrollbar">
      {submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-event-big.svg"
        parentMenu={t('common.menu.event')}
        currentMenu={t('event.briefing.title2')}
      />
      <BriefingEditor
        submit={submit}
      />
    </div>
  );
}

export default BriefingCreate;
